import { NgModule } from '@angular/core';
import { CommonModule, FormStyle } from '@angular/common';
import { ExampleComponent } from './example/example.component';
import { HighlightModule } from 'ngx-highlightjs';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        HighlightModule,
        FormsModule
    ],
    declarations: [ExampleComponent],
    exports: [ExampleComponent]
})
export class SharedModule {
}